<script setup lang="ts">
const { isOnline, offlineAt } = useNetwork();
const offlineDate = computed(() => (offlineAt.value ? new Date(offlineAt.value) : null));
</script>

<template>
  <div class="h-[100dvh] overflow-hidden">
    <Statusbar :is-connected="isOnline" :offline-at="offlineDate" />

    <Tabbar />

    <div class="h-[78dvh] md:h-[84dvh] overflow-hidden">
      <slot></slot>
    </div>
  </div>
</template>
